/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ProductDraftsUserControllerDiscardMutationResponse,
  ProductDraftsUserControllerDiscardPathParams,
  ProductDraftsUserControllerDiscard401,
  ProductDraftsUserControllerDiscard404,
  ProductDraftsUserControllerDiscard409,
} from '../../types/ProductDraftsUserControllerDiscard.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { productDraftsUserDiscard } from '../../methods/productDraftsUserDiscard.ts';
import { useMutation } from '@tanstack/react-query';

export const productDraftsUserDiscardMutationKey = () => [{ url: '/api/user/product-drafts/:id' }] as const;

export type ProductDraftsUserDiscardMutationKey = ReturnType<typeof productDraftsUserDiscardMutationKey>;

/**
 * {@link /api/user/product-drafts/:id}
 */
export function useProductDraftsUserDiscard<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ProductDraftsUserControllerDiscardMutationResponse,
      ResponseErrorConfig<
        | ProductDraftsUserControllerDiscard401
        | ProductDraftsUserControllerDiscard404
        | ProductDraftsUserControllerDiscard409
      >,
      { id: ProductDraftsUserControllerDiscardPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? productDraftsUserDiscardMutationKey();

  return useMutation<
    ProductDraftsUserControllerDiscardMutationResponse,
    ResponseErrorConfig<
      | ProductDraftsUserControllerDiscard401
      | ProductDraftsUserControllerDiscard404
      | ProductDraftsUserControllerDiscard409
    >,
    { id: ProductDraftsUserControllerDiscardPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return productDraftsUserDiscard(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
